module.exports = __webpack_public_path__ + "img/nodata.b50ac40e.png";